<template>
    <div :style="skin.menu_sports.nav_bar" class="px-3 py-2 pb-0 m-0">
        <div class="px-2 pe-3">
              <carousel
              :paginationEnabled="false"
              :autoplay="false"
              :navigationEnabled="true"
              :autoplayTimeout="3000"
              :autoplayHoverPause="true"
              :perPageCustom="[[300, 4],[451, 6],[1024, sports.main.length]]">
                  <slide v-for="(sport) in sports.main" v-bind:key="sport.name">
                      <div v-if="sport.name=='bet_records'" @click="show_records()">
                          <div class="center_div"><div :class="sport.icon" :style="skin.menu_sports.icon"></div></div>
                          <div class="text-center"><span :style="skin.menu_sports.icon_text">{{ translation[sport.name][language] }}</span></div>
                      </div>
                      <div v-else-if="sport.name=='more'">
                          <div data-bs-toggle="modal" data-bs-target="#sportsModal">
                              <div class="center_div"><div :class="sport.icon" :style="skin.menu_sports.icon"></div></div>
                              <div class="text-center"><span :style="skin.menu_sports.icon_text">{{ translation[sport.name][language] }} ({{ sports.more.length }})</span></div>
                          </div>
                      </div>
                      <div v-else @click="select_sport(sport)">
                          <div class="center_div"><div :class="sport.icon" :style="skin.menu_sports.icon"></div></div>
                          <div class="text-center"><span :style="skin.menu_sports.icon_text">{{ sport.name }} ({{ sport.count }})</span></div>
                      </div>
                  </slide>
              </carousel>
        </div>
        <!-- Modal -->
      <div class="modal fade" id="sportsModal" tabindex="-1" aria-labelledby="sportsModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-lg">
              <div class="modal-content" :style="skin.menu_sports.nav_bar">
                  <div class="modal-header">
                      <button id="closeSports" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                  </div>
                  <div class="modal-body">
                      <div class="row">
                          <div v-for="(sport_add) in sports.more" class="col-lg-3 col-sm-6 pb-2">
                              <span class="d-flex" @click="select_sport(sport_add)" style="cursor: pointer;">
                                  <span :class="sport_add.icon" class="mx-1" style="width:20px;height:20px"></span>
                                  <span style="width: 75%;"><span>{{ sport_add.name }}</span> ({{ sport_add.count }})</span>
                              </span>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </div>
  </template>
  <script>
  import { Carousel, Slide } from 'vue-carousel';
  export default {
       name:"menu_sports",
       components:{Carousel,Slide},
       props:['skin','translation','language','sports_data'],
       data(){
           return{
               sports_ids:[1,3,4,11,6,2,17,41,19],
               sports_main:{
                  1:{name:"soccer",icon:"icon_futbol"},
                  3:{name:'basket',icon:"icon_basket"},
                  4:{name:'tennis',icon:"icon_tenis"},
                  11:{name:'baseball',icon:"icon_beisball"},
                  6:{name:'american_futbol',icon:"icon_futAmericano"},
                  2:{name:'hockey',icon:"icon_hockey"},
                  17:{name:'boxing',icon:"icon_boxeo"},
                  41:{name:'table_tennis',icon:"icon_tenis_mesa"},
                  19:{name:'cricket',icon:"icon_cricket"}
               },
               sport_icons:{
                  1:"icon_futbol",
                  2:"icon_hockey",
                  3:"icon_basket",
                  4:"icon_tenis",
                  11:"icon_beisball",
                  104:"icon_beisball",
                  26:"icon_futsal",
                  24:"icon_futsal",
                  41:"icon_tenis_mesa",
                  73:"icon_eGames",
                  74:"icon_eGames",
                  75:"icon_eGames",
                  76:"icon_eGames",
                  77:"icon_eGames",
                  80:"icon_eGames",
                  82:"icon_eGames",
                  83:"icon_eGames",
                  71:"icon_eGames",
                  158:"icon_eGames",
                  260:"icon_eGames",
                  208:"icon_eGames",
                  185:"icon_eGames",
                  205:"icon_basket",
                  9:"icon_badminton",
                  29:"icon_balon_mano",
                  37:"icon_rugby",
                  39:"icon_snoker",
                  22:"icon_dardos",
                  14:"icon_volleyball",
                  19:"icon_cricket",
                  42:"icon_waterpolo",
                  27:"icon_golf",
                  36:"icon_rugby1",
                  5:"icon_volleyball",
                  6:"icon_futAmericano",
                  8:"icon_futbol_australiano",
                  17:"icon_boxeo",
                  21:"icon_ciclismo",
                  25:"icon_race",
                  33:"icon_race",
                  32:"icon_race",
                  101:"icon_race",
                  44:"icon_mma",
                  70:"icon_hurling",
                  88:"icon_squash",
                  90:"icon_specials"
              },
              render:true
           }
       },
       computed:{
           user(){
              return this.$store.getters['getUserData'];
           },
           sports(){
              let sports = {main:[],more:[]}
              //let user = this.$store.getters['getUserData'];
              let competitions_banned = this.$store.getters['getConfig'].SkinConfig.main.hideCompetitionsPrematch; 
              let regions_banned = this.$store.getters['getConfig'].SkinConfig.main.hideRegionsPrematch;
            //   if(user.token!=""){
            //       sports.main.push({
            //           name:"bet_records",
            //           icon:"icon_historial",
            //       })
            //   }
              if(this.$props.sports_data){
                  Object.keys(this.$props.sports_data).forEach(sport => {
                      let count=0;
                      if(this.$props.sports_data[sport].region){
                          Object.keys(this.$props.sports_data[sport].region).forEach(key => {
                              if(this.$props.sports_data[sport].region[key] && this.$props.sports_data[sport].region[key].competition && !regions_banned.includes(this.$props.sports_data[sport].region[key].alias)){
                                  Object.keys(this.$props.sports_data[sport].region[key].competition).forEach(key2 => {
                                  let banned1_check = false;
                                  if(this.$props.sports_data[sport].region[key].competition[key2] && this.$props.sports_data[sport].region[key].competition[key2].game){
                                      competitions_banned.forEach(word => {
                                      if(this.$props.sports_data[sport].region[key].competition[key2].name.includes(word)){
                                          banned1_check = true;
                                      }
                                      });
                                  }
                                  if(this.$props.sports_data[sport].region[key].competition[key2] && this.$props.sports_data[sport].region[key].competition[key2].game && !banned1_check){
                                      Object.keys(this.$props.sports_data[sport].region[key].competition[key2].game).forEach(key3 => {
                                          if(this.$props.sports_data[sport].region[key].competition[key2].game[key3] && this.$props.sports_data[sport].region[key].competition[key2].game[key3].info){
                                              count++;
                                          }
                                      })
                                  }
                                  })
                              }
                          })
                      }
                      if(this.sports_ids.includes(parseInt(sport))){
                          sports.main.push({
                              name:this.$props.translation[this.sports_main[sport].name][this.$props.language],
                              icon:this.sport_icons[sport],
                              id_live:sport,
                              count:count
                          })
                      }
                      else{
                          sports.more.push({
                              name:this.$props.sports_data[sport].name,
                              icon:this.sport_icons[sport]??"icon_specials",
                              id_live:sport,
                              count:count
                          })
                      }
                  })
              }
              if(sports.more.length>0){
                  sports.main.push({
                      name:"more",
                      icon:"icon_specials"
                  })
              }
              return sports;
          },
       },
       methods:{
          select_sport(data){
              if(document.getElementById("closeSports")){
                  document.getElementById("closeSports").click();
              }
              this.$store.dispatch('setLobbyView','sport');
              this.$root.$emit('select_sport',data);
          },
          show_records(){
              this.$store.dispatch('setLobbyView','records');
          }
      },
  }
  </script>
  
  <style>
      .center_div{
          width: 40px; /* Can be in percentage also. */
          height: auto;
          margin: 0 auto;
          padding: 0px;
          position: relative;
      }
      .long_text {
        display: -webkit-box;
        max-width: 200px;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        -webkit-box-align: center;
        overflow: hidden;
    }
  </style>